
export const publicFunClass= {
    data(){
      return{
        pickerOptions: {
          shortcuts: [{
            text: '昨天',
            onClick(picker) {
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * 1);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
              const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
              const end = startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '今天',
            onClick(picker) {
              const time = new Date();
              const month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
              const date=time.getDate()<10?"0"+time.getDate():time.getDate();
              const start=time.getFullYear() + '-' + month + '-' + date+" 00:00:00";
              const end = time.getFullYear() + '-' + month + '-' + date+" 23:59:59";
              picker.$emit('pick',  [start, end]);
            }
          }, {
            text: '上周',
            onClick(picker) {
              const now = new Date();
              const day = now.getDay();
              const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
              const week=parseInt(weeks[day]);
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * (week+6));
              const endTime = new Date();
              endTime.setTime(endTime.getTime() - 1000 * 3600 * 24 * week);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
              const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
              const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
              const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
              const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '本周',
            onClick(picker) {
              const now = new Date();
              const day = now.getDay();
              const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
              const week=parseInt(weeks[day]);
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * (week-1));
              const endTime = new Date();
              endTime.setTime(startTime.getTime() + 1000 * 3600 * 24 * 6);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
              const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
              const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
              const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
              const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '上月',
            onClick(picker) {
              const startTime = new Date();
              const currentTime = new Date();
              currentTime.setDate(0);
              let count=currentTime.getDate();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * count);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
              const end = startTime.getFullYear() + '-' + startMonth + '-' + count+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '本月',
            onClick(picker) {
              const startTime = new Date();
              let curMonth = startTime.getMonth()+1;// 加一是因为月份从0开始
              let curDays=startTime.getDate();
              const startMonth = curMonth < 10 ? ("0" + curMonth) : curMonth;
              curDays = curDays < 10 ? ("0" + curDays) : curDays;
              const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
              const end = startTime.getFullYear() + '-' + startMonth + '-' + curDays + " 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '去年',
            onClick(picker) {
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * 365);
              const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
              const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '今年',
            onClick(picker) {
              const startTime = new Date();
              const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
              const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },]
        },
        pickerOptionsAndFuture: {
          shortcuts: [{
            text: '昨天',
            onClick(picker) {
              const startTime = new Date();
              startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * 1);
              const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
              const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
              const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
              const end = startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 23:59:59";
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '今天',
            onClick(picker) {
              const time = new Date();
              const month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
              const date=time.getDate()<10?"0"+time.getDate():time.getDate();
              const start=time.getFullYear() + '-' + month + '-' + date+" 00:00:00";
              const end = time.getFullYear() + '-' + month + '-' + date+" 23:59:59";
              picker.$emit('pick',  [start, end]);
            }
          }, {
              text: '明天',
              onClick(picker) {
                const startTime = new Date();
                startTime.setTime(startTime.getTime() + 1000 * 3600 * 24 * 1);
                const endTime = new Date();
                endTime.setTime(endTime.getTime() + 1000 * 3600 * 24 * 1);
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
                const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
                const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
                const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
                const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '上周',
              onClick(picker) {
                const now = new Date();
                const day = now.getDay();
                const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
                const week=parseInt(weeks[day]);
                const startTime = new Date();
                startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * (week+6));
                const endTime = new Date();
                endTime.setTime(endTime.getTime() - 1000 * 3600 * 24 * week);
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
                const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
                const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
                const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
                const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '本周',
              onClick(picker) {
                const now = new Date();
                const day = now.getDay();
                const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
                const week=parseInt(weeks[day]);
                const startTime = new Date();
                startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * (week-1));
                const endTime = new Date();
                endTime.setTime(startTime.getTime() + 1000 * 3600 * 24 * 6);
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
                const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
                const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
                const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
                const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '下周',
              onClick(picker) {
                const now = new Date();
                const day = now.getDay();
                const weeks = new Array("7", "1", "2", "3", "4", "5", "6");
                const week=7-parseInt(weeks[day]);
                const startTime = new Date();
                startTime.setTime(startTime.getTime() + 1000 * 3600 * 24 *(week+1));
                const endTime = new Date();
                endTime.setTime(endTime.getTime() + 1000 * 3600 * 24 * (week+7));
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
                const endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
                const endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
                const start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
                const end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '上月',
              onClick(picker) {
                const startTime = new Date();
                const currentTime = new Date();
                currentTime.setDate(0);
                let count=currentTime.getDate();
                startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * count);
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
                const end = startTime.getFullYear() + '-' + startMonth + '-' + count+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '本月',
              onClick(picker) {
                const startTime = new Date();
                let curMonth = startTime.getMonth()+1;// 加一是因为月份从0开始
                let curDays=startTime.getDate();
                const startMonth = curMonth < 10 ? ("0" + curMonth) : curMonth;
                curDays = curDays < 10 ? ("0" + curDays) : curDays;
                const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
                const end = startTime.getFullYear() + '-' + startMonth + '-' + curDays + " 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '下月',
              onClick(picker) {
                const startTime = new Date();
                let curMonth = startTime.getMonth();
                startTime.setMonth(curMonth + 2);
                startTime.setDate(0);
                let count=startTime.getDate();
                const startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
                const start=startTime.getFullYear() + '-' + startMonth + '-01' +" 00:00:00";
                const end = startTime.getFullYear() + '-' + startMonth + '-' + count+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '去年',
              onClick(picker) {
                const startTime = new Date();
                startTime.setTime(startTime.getTime() - 1000 * 3600 * 24 * 365);
                const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
                const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '今年',
              onClick(picker) {
                const startTime = new Date();
                const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
                const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '明年',
              onClick(picker) {
                const startTime = new Date();
                startTime.setTime(startTime.getTime() + 1000 * 3600 * 24 * 365);
                const start=startTime.getFullYear() + '-01-01'+" 00:00:00";
                const end = startTime.getFullYear() + '-12-31'+" 23:59:59";
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
      }
    },
    methods: {
      getDateByDatePicker:function(t){
        if(t == undefined || t == ''){
          return t;
        }
        let date = new Date(t);
        let month=(date.getMonth() + 1)<10?"0"+(date.getMonth() + 1):(date.getMonth() + 1);
        let Date=date.getDate()<10?"0"+date.getDate():date.getDate();
        let Hours=date.getHours()<10?"0"+date.getHours():date.getHours();
        let Minutes=date.getMinutes()<10?"0"+date.getMinutes():date.getMinutes();
        let Seconds=date.getSeconds()<10?"0"+date.getSeconds():date.getSeconds();
        let datetime=date.getFullYear() + '-' + month + '-' + Date+' '+Hours+ ':' +Minutes+ ':' +Seconds;
        return datetime;
      },
      //获取当前时间
      getNowTime:function(){
        let date = new Date();
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        let hour = date.getHours();
        let second = date.getSeconds();
        let minute = date.getMinutes()
        if (hour >= 0 && hour <= 9) {
          hour = "0" + hour;
        }
        if (second >= 0 && second <= 9) {
          second = "0" + second;
        }
        if (minute >= 0 && minute <= 9) {
          minute = "0" + minute;
        }
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        let currentDate = date.getFullYear() + "-" + month + "-" + strDate
          + " " + hour + ":" + minute + ":" + second;
        return currentDate;
      },
      getSearchTime:function(sign){
        let data= 0;
        if(sign=='2'){
          data= 1000 * 3600 * 24 * 6;
        }
        if(sign=='3'){
          data= 1000 * 3600 * 24 * 29;
        }
        let startTime = new Date();
        startTime.setTime(startTime.getTime() - data);
        let endTime = new Date();
        let startMonth=(startTime.getMonth() + 1)<10?"0"+(startTime.getMonth() + 1):(startTime.getMonth() + 1);
        let startDate=startTime.getDate()<10?"0"+startTime.getDate():startTime.getDate();
        let endMonth=(endTime.getMonth() + 1)<10?"0"+(endTime.getMonth() + 1):(endTime.getMonth() + 1);
        let endDate=endTime.getDate()<10?"0"+endTime.getDate():endTime.getDate();
        let start=startTime.getFullYear() + '-' + startMonth + '-' + startDate+" 00:00:00";
        let end = endTime.getFullYear() + '-' + endMonth + '-' + endDate+" 23:59:59";
        return start+","+end
      },
      timeChange:function(time){
        let month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
        let Date=time.getDate()<10?"0"+time.getDate():time.getDate();
        let Hours=time.getHours()<10?"0"+time.getHours():time.getHours();
        let Minutes=time.getMinutes()<10?"0"+time.getMinutes():time.getMinutes();
        let Seconds=time.getSeconds()<10?"0"+time.getSeconds():time.getSeconds();
        let datetime=time.getFullYear() + '-' + month + '-' + Date+' '+Hours+ ':' +Minutes+ ':' +Seconds;
        return datetime
      },
      getDate:function(time,sign){
        let month=(time.getMonth() + 1)<10?"0"+(time.getMonth() + 1):(time.getMonth() + 1);
        let Date=time.getDate()<10?"0"+time.getDate():time.getDate();
        return time.getFullYear() + '-' + month + '-' + Date+" "+sign
      },
      //计算屏幕高度
      mountHeight:function (reduceHeight) {
        let clientHeight=document.documentElement.clientHeight;
        let actualHeight=clientHeight-reduceHeight+'px';
        return actualHeight;
      },
      handleScroll () {
        let that=this;
        // 保存滚动事件监听器引用，便于后续清理
        this.scrollEventListener = (res) => {
          clearInterval(that.scrollInterval);
          that.scrollbar=res.timeStamp;
          that.historyScroll=res.timeStamp;
          that.tableClass=false;
          that.scrollInterval= setInterval(() =>{
            if(that.scrollbar==that.historyScroll){
              clearInterval(that.scrollInterval);
              that.tableClass=true;
              clearInterval(that.scrollInterval);
            }
          },1000);
        };
        this.$refs.selection.bodyWrapper.addEventListener('scroll', this.scrollEventListener, true);
      },
      // 组件销毁时调用的清理方法
      beforeDestroy() {
        // 清理滚动事件监听器
        if (this.$refs.selection && this.$refs.selection.bodyWrapper && this.scrollEventListener) {
          this.$refs.selection.bodyWrapper.removeEventListener('scroll', this.scrollEventListener, true);
        }
        // 清理定时器
        if (this.scrollInterval) {
          clearInterval(this.scrollInterval);
        }
      },
      // 表情替换
      replaceEmoji(lastMsg){
        if(lastMsg && lastMsg.indexOf('/:') > -1){
          for(let i = 0; i < this.emojiList.length; i++){
            for(let n = 0; n < this.emojiList[i].length; n++){
              let newChar = this.htmlToString(this.emojiList[i][n].chars);
              lastMsg = lastMsg.replace(new RegExp(RegExp.escape(newChar),'g'),"[表情]");
            }
          }
        }
        return lastMsg;
      },
      // 日期格式化
      formatDate: function(time, fmt){
        return fmt.replace("yyyy",time.getFullYear()).replace("MM",time.getMonth()+1).replace("dd",time.getDate())
               .replace("hh",(time.getHours() < 10 ? "0" + time.getHours() : time.getHours()))
               .replace("mm",(time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes()))
               .replace("ss",(time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds()))
      },
      // 时间格式转换，把昨天的时间修改成昨天两字，今年的日期不显示年，今天的时间不显示月份
      timeFormat: function(customTime){
        let time = new Date();
        // 今年1号的零点
        let yearStart = this.formatDate(time,"yyyy") + "-1-1 00:00:00";

        customTime= new Date(Date.parse(customTime));
        yearStart= new Date(Date.parse(yearStart));
        if(customTime > yearStart){  //今年
        // 今天的零点
        let todayStart = this.formatDate(time,"yyyy-MM-dd") + " 00:00:00";
          todayStart= new Date(Date.parse(todayStart));
          if(customTime > todayStart){  //今天
             return this.formatDate(customTime,"hh:mm:ss");
          }else{ //昨天或以前
            let yesterdayStart = todayStart.getTime() - 24*60*60*1000; //昨天零点
            if(customTime.getTime() < yesterdayStart){ //比昨天更早的时间
              return this.formatDate(customTime,"MM-dd hh:mm:ss");
            }else{
              return this.$t("yesterday")+" " + this.formatDate(customTime,"hh:mm:ss");
            }

          }
        }else{ //去年
          return this.formatDate(customTime,"yyyy-MM-dd hh:mm:ss");
        }
      },
      // 将秒转换成时分秒
      formatSeconds: function(seconds){
        if(!seconds){
          seconds = 0;
        }
        let theTime = parseInt(seconds);// 秒
        let middle= 0;// 分
        let hour= 0;// 小时

        if(theTime > 60) {
            middle= parseInt(theTime / 60);
            theTime = parseInt(theTime % 60);
            if(middle> 60) {
                hour= parseInt(middle / 60);
                middle= parseInt(middle % 60);
            }
        }
        let result = ":"+(parseInt(theTime) < 10 ? "0"+parseInt(theTime) : parseInt(theTime));
        if(middle > 0) {
            result = ":"+(parseInt(middle) < 10 ? "0"+parseInt(middle) : parseInt(middle)) + result;
        }else{
          result = ":00" + result;
        }
        if(hour> 0) {
            result = (parseInt(hour) < 10 ? "0" + parseInt(hour) : parseInt(hour)) + result;
        }else{
          result = "00" + result;
        }
        return result;
      },
      //一般数组去重
      arrayDeDuplication:function (array) {
        for(let i=0; i<array.length; i++){
          for(let j=i+1; j<array.length; j++){
            if(array[i] == array[j]){
              array.splice(j,1);
              j--;
            }
          }
        }
        return array;
      },
    },
};




// WEBPACK FOOTER //
// ./src/libs/PublicFunClass.js